<template>
  <nav class="reservation-navigation">
    <span
      class="link"
      :class="
        getState(
          [Route.NumberOfTravellers, Route.TravellersData],
          [Route.ServicesData, Route.InvoiceData, Route.Overview]
        )
      "
      @click="goToRoute(Route.TravellersData)"
    >
      Cestujúci

      <BartoIcon class="reservation-navigation-check" icon="reservation-navigation-check" />
    </span>

    <BartoIcon class="link-arrow" icon="reservation-navigation-arrow" />

    <span
      class="link"
      :class="getState([Route.ServicesData], [Route.InvoiceData, Route.Overview])"
      @click="goToRoute(Route.ServicesData)"
    >
      Služby

      <BartoIcon class="reservation-navigation-check" icon="reservation-navigation-check" />
    </span>

    <BartoIcon class="link-arrow" icon="reservation-navigation-arrow" />

    <span
      class="link"
      :class="getState([Route.InvoiceData], [Route.Overview])"
      @click="goToRoute(Route.InvoiceData)"
    >
      Fakturačné údaje
      <BartoIcon class="reservation-navigation-check" icon="reservation-navigation-check" />
    </span>

    <BartoIcon v-if="isMobile" class="link-arrow" icon="reservation-navigation-arrow" />

    <span
      v-if="isMobile"
      class="link"
      :class="getState([Route.Overview], [])"
      @click="goToRoute(Route.Overview)"
    >
      Zhrnutie

      <BartoIcon class="reservation-navigation-check" icon="reservation-navigation-check" />
    </span>
  </nav>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { pushRoute, Route } from '../router';
import { useDevice } from '../modules/useDevice';
import BartoIcon from './BartoIcon.vue';

const currentRoute = useRoute();
const { isMobile } = useDevice();

const getState = (activeRoutes: Route[], finishedRoutes: Route[]) => ({
  active: activeRoutes.some((route) => route === currentRoute.name),
  finished: finishedRoutes.some((route) => route === currentRoute.name),
});

const goToRoute = (route: Route) => {
  switch (route) {
    case Route.TravellersData:
      return (
        [Route.ServicesData, Route.InvoiceData, Route.Overview].includes(
          currentRoute.name as Route
        ) && pushRoute(route)
      );

    case Route.ServicesData:
      return (
        [Route.InvoiceData, Route.Overview].includes(currentRoute.name as Route) && pushRoute(route)
      );

    case Route.InvoiceData:
      return [Route.Overview].includes(currentRoute.name as Route) && pushRoute(route);

    default:
      return undefined;
  }
};
</script>
